import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/opt/build/repo/src/contexts/AuthContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LanguageProvider"] */ "/opt/build/repo/src/contexts/LanguageContext.tsx");
;
import(/* webpackMode: "eager" */ "/opt/build/repo/src/styles/index.css");
